export const FIELD_TYPE = Object.freeze({
  STRING: "string",
  TEXT: "text",
  SINGLE_CHOICE_LIST: "singlechoicelist",
  MULTIPLE_CHOICE_LIST: "multiplechoicelist",
  DATE: "date",
  DATE_TIME: "datetime",
  DATE_TIME_TIMEZONE: "datetimetimezone",
  DATE_WITH_USER_TIMEZONE: "datewithusertimezone",
  DATE_WITH_TIMEZONE: "datewithtimezone",
  DECIMAL: "decimal",
  NUMBER: "number",
  EMAIL: "email",
  FILE: "file",
  NAME: "name",
  RICH_TEXT: "richtext",
  RICH_TEXT_EDITOR: "richtexteditor",
  CHECKBOX: "checkbox",
  BOOLEAN: "boolean",
  ZIP: "zip",
  STATE: "state",
  COUNTY: "county",
  CITY: "city",
  COUNTRY: "country",
  TIMEZONE: "timezone",
  ADDRESS: "address",
  GEOPOINT: "geopoint",
  ASSIGNMENT_METHOD: "assignmentmethod",
  TAG: "tag",
});

export const DATE_FIELD_TYPES = Object.freeze([
  FIELD_TYPE.DATE,
  FIELD_TYPE.DATE_TIME,
  FIELD_TYPE.DATE_TIME_TIMEZONE,
  FIELD_TYPE.DATE_WITH_USER_TIMEZONE,
  FIELD_TYPE.DATE_WITH_TIMEZONE,
]);

export const WIDE_FIELD_TYPES = Object.freeze([
  FIELD_TYPE.RICH_TEXT,
  FIELD_TYPE.RICH_TEXT_EDITOR,
  FIELD_TYPE.ASSIGNMENT_METHOD,
]);

export const SELF_LAYOUT_FIELD_TYPES = Object.freeze([
  FIELD_TYPE.ASSIGNMENT_METHOD,
  FIELD_TYPE.TAG,
]);

export const CHECKBOX_FIELD_TYPES = Object.freeze([
  FIELD_TYPE.CHECKBOX,
  FIELD_TYPE.BOOLEAN,
]);

export const KNOWN_FIELD_TYPES = Object.freeze(
  new Set([
    FIELD_TYPE.STRING,
    FIELD_TYPE.TEXT,
    FIELD_TYPE.NUMBER,
    FIELD_TYPE.DECIMAL,
    FIELD_TYPE.EMAIL,
    FIELD_TYPE.DATE,
    FIELD_TYPE.DATE_TIME,
    FIELD_TYPE.DATE_TIME_TIMEZONE,
    FIELD_TYPE.DATE_WITH_USER_TIMEZONE,
    FIELD_TYPE.DATE_WITH_TIMEZONE,
    FIELD_TYPE.SINGLE_CHOICE_LIST,
    FIELD_TYPE.MULTIPLE_CHOICE_LIST,
    FIELD_TYPE.ADDRESS,
    FIELD_TYPE.NAME,
    FIELD_TYPE.TIMEZONE,
    FIELD_TYPE.FILE,
    FIELD_TYPE.GEOPOINT,
    FIELD_TYPE.ZIP,
    FIELD_TYPE.CITY,
    FIELD_TYPE.STATE,
    FIELD_TYPE.COUNTY,
    FIELD_TYPE.COUNTRY,
    FIELD_TYPE.RICH_TEXT,
    FIELD_TYPE.RICH_TEXT_EDITOR,
    FIELD_TYPE.ASSIGNMENT_METHOD,
    FIELD_TYPE.TAG,
  ]),
);